module.exports = __webpack_public_path__ + "static/media/Trouser Image - Opt 1.e7584009.jpg";